"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.4 17.902A8 8 0 016.098 6.6C6.821 12.5 11.5 17.18 17.401 17.902zM18.93 16C12.91 15.962 8.038 11.09 8 5.07V5c0-.777.08-1.535.234-2.267A9.984 9.984 0 006.04 3.97 9.985 9.985 0 002 11.999c0 5.524 4.477 10 10 10a9.985 9.985 0 008.03-4.04 9.985 9.985 0 001.236-2.193c-.73.153-1.489.234-2.266.234h-.07z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;